import React, { useContext, useEffect } from 'react'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { UpdateClientStatus } from 'api/Clients/Types/UpdateClientStatus'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchCountriesAction } from 'store/identity/identity.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { IdentityApiClient } from 'utils/api/identityApi'
import { AuthSessionContext } from 'utils/AuthContext'
import { isEmpty } from 'utils/is-empty'

import { ClientDetailsContactForm } from './ClientDetailsContactForm'

interface Props {
  data: ClientDetailedDto
  forceRefresh(): void
  updateClientStatus(values: UpdateClientStatus): void
}
const ClientDetailsContactPage: React.FC<Props> = ({ data, forceRefresh, updateClientStatus }) => {
  const setToast = useContext(ToastContext)
  const [auth] = useContext(AuthSessionContext)

  const countries = useAppSelector((state) => state.identity.countries)
  const permissions = auth?.permissions || []
  const dispatch = useAppDispatch()

  const identityApiClient = useApiClient(IdentityApiClient)
  const clientsApiClient = useApiClient(ClientsApiClient)

  useEffect(() => {
    if (isEmpty(countries)) {
      dispatch(fetchCountriesAction(identityApiClient))
    }
  }, [dispatch, countries]) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (values: ClientDetailedDto) => {
    const { companyDetails, ...individualDetailsPayload } = values
    await clientsApiClient.updateClientIndividualDetails(individualDetailsPayload, false)
    setToast(successToast('Client updated successfully.'))
    forceRefresh()
  }

  if (!data) {
    return null
  }
  return (
    <ClientDetailsContactForm
      onSubmit={onSubmit}
      clientDetails={data}
      updateClientStatus={updateClientStatus}
      countries={countries}
      permissions={permissions}
    />
  )
}

export default ClientDetailsContactPage
